<script setup lang="ts">
import type { SettingElementInterface } from '@/types/items';
import type { ModifierConfig } from '@/types/browser';

const props = defineProps<{
    element: SettingElementInterface;
    allowMultiple?: boolean,
    modifierConfig?: ModifierConfig;
    variant?: 'link' | 'primary';
    block?: boolean;
    dropDownIcon?: boolean;
    label?: string;
}>();

const emit = defineEmits<{
    add: [element: SettingElementInterface, modifiers: Record<string, string>];
}>();

const hasModifiers = (): boolean => {
    return !!props.modifierConfig?.condition(props.element);
};

const onOptionClick = (value: string) => {
    emit('add', props.element, { [props.modifierConfig!.key]: value });
};

const onPlainClick = () => {
    emit('add', props.element, {});
};
</script>

<template>
    <div v-if="hasModifiers()" class="btn-group" :class="{ 'd-block': block }">
        <button
            type="button"
            class="btn btn-sm"
            :class="[
                variant === 'primary' ? 'btn-primary' : 'btn-link p-0',
                { 'd-block w-100': block },
                { 'dropdown-toggle': dropDownIcon }
            ]"
            data-bs-toggle="dropdown"
            data-bs-auto-close="true"
        >
            <span v-if="variant === 'primary'" v-html="label"></span>
            <span v-else class="fa-light fa-plus text-primary"></span>
        </button>
        <ul class="dropdown-menu">
            <li v-for="opt in modifierConfig!.options" :key="opt.value">
                <button class="dropdown-item" type="button" @click.stop="onOptionClick(opt.value)">
                    {{ opt.label }}
                </button>
            </li>
        </ul>
    </div>
    <button
        v-else-if="variant === 'primary'"
        type="button"
        class="btn btn-primary btn-sm"
        :class="{ 'd-block w-100': block }"
        @click.stop="onPlainClick"
        v-html="label"
    ></button>
    <button
        v-else
        type="button"
        class="btn btn-sm btn-link p-0"
        @click.stop="onPlainClick"
        data-bs-toggle="tooltip"
        :title="allowMultiple ? 'Add Again' : 'Add'"
    >
        <span class="fa-light text-primary" :class="allowMultiple ? 'fa-clone-plus' : 'fa-plus'"></span>
    </button>
</template>

<style scoped>
.btn-group.d-block .dropdown-menu {
    left: 50% !important;
    right: auto !important;
    transform: translate(-50%, 33px) !important;
}
</style>
